import { createTheme } from "@mui/material";
// import gtWalsheim from "./Fonts/GT-Walsheim-Pro"

export const theme = createTheme({
  typography: {
    fontFamily: "GT Walsheim Pro",
    h1: {
      fontFamily: "inherit",
      fontWeight: 700,
      fontSize: "60px",
      lineHeight: "78px",
      letterSpacing: "0.5px",
      textAlign: "left",
    },
    h2: {
      fontFamily: "inherit",
      fontWeight: 700,
      fontSize: "45px",
      lineHeight: "64px",
      letterSpacing: "0.5px",
      textAlign: "center",
    },
    h3: {
      fontFamily: "inherit",
      fontWeight: 700,
      fontSize: "38px",
      lineHeight: "56px",
      letterSpacing: "0.5px",
    },
    h4: {
      fontFamily: "inherit",
      fontSize: "30px",
      fontWeight: 700,
      lineHeight: "34px",
      letterSpacing: "0.5px",
      textAlign: "left",
    },
    h5: {
      fontFamily: "inherit",
      fontFize: "26px",
      fontWeight: 700,
      lineHeight: "32px",
      letterSpacing: "0.5px",
      textAlign: "left",
    },
    h6: {
      fontFamily: "inherit",
      fontSize: "22px",
      fontWeight: 700,
      lineHeight: "32px",
      letterSpacing: "0.5px",
      textAlign: "left",
    },
    subtitle1: {
      fontFamily: "inherit",
      fontSize: "18px",
      fontWeight: 400,
      lineHeight: "32px",
      letterSpacing: "0.02em",
    },
    subtitle2: {
      fontFamily: "inherit",
      fontSize: "16px",
      fontWeight: 400,
      lineHeight: "24px",
      letterSpacing: "0.02em",
    },
    // body1: {
    //   fontFamily: "inherit",
    //   fontSize: "14px",
    //   fontWeight: 400,
    //   lineHeight: "24px",
    //   letterSpacing: "0.02em",
    // },
    // body2: {
    //   fontFamily: "inherit",
    //   fontSize: "12px",
    //   fontWeight: 400,
    //   lineHeight: "18px",
    //   letterSpacing: "0.02em",
    // },
    button: {
      fontSize: "1rem",
      fontWeight: 500,
      lineHeight: "1.5rem",
      letterSpacing: "0.02em",
      textTransform: "none",
    },
  },
  palette: {
    primary: {
      main: "#09005B",
      contrastText: "#FFF",
    },
    secondary: {
      main: "#00C703",
      dark: "#00A603",
      contrastText: "#FFF",
    },
    common: {
      black: "#0E0E0E",
    },
    text: {
      primary: "#0E0E0E",
      secondary: "#5E5E5E",
      disabled: "#868686",
    },
  },
});
